<form [formGroup]="form" (ngSubmit)="save()">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <div *ngIf="!loading" class="edit-actions">
        <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
        <button *ngIf="!loadingAction" type="button" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
  </button>
        <button *ngIf="!loadingAction" matTooltip="Guardar" (click)="save()" mat-icon-button class="card-inline">
    <mat-icon>done</mat-icon>
  </button>
    </div>
    <mat-tab-group #tabGroup>
        <mat-tab label="Configuración">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <div class="card-container mat-elevation-z1">
                        <div class="card-content">
                            <mat-form-field class="margin-right-small margin-top-xx">
                                <input matInput placeholder="Nombre" formControlName="Name" required>
                                <mat-error *ngIf="f.Name.errors  && f.Name.errors.required">
                                    Ingrese el nombre del escaner
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="margin-right-small margin-top-xx">
                                <input matInput placeholder="Ip y puerto" formControlName="Ip" required>
                                <mat-hint>ej: 127.0.0.1:4000</mat-hint>
                                <mat-error *ngIf="f.Ip.errors  && f.Ip.errors.required">
                                    Ingrese la ip y puerto (ip:puerto)
                                </mat-error>

                            </mat-form-field>
                            <mat-checkbox class="margin-right-small margin-top-xx" formControlName="ExecuteCommand">Es linux</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</form>